import 'select2';

const $ = jQuery;

export const selectInit = () => {
  $('.wpcf7').ready(function () {
    $('.wpcf7-select').each(function() {
      const $select = $(this);

      $select.select2({
        minimumResultsForSearch: Infinity
      });
    });
  });

  $('.wpcf7').on('select2:select', () => {
    const inputElement = document.querySelector('.wpcf7-form-control');
    inputElement.click();
  })
};
